import { FC } from 'react';

import { getUserId, getEverLoggedIn } from 'dibs-cookie-jar';
import { sessionStorage } from 'dibs-browser-storage';

import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

export const SEM_REGISTRATION_SHOWN_KEY = 'semRegistrationShown';

const importSemRegistrationModal = async (): Promise<FC> =>
    (
        await import(
            /* webpackChunkName: "SemRegistrationModal" */
            './SemRegistrationModal'
        )
    ).default;

export const wasSemRegistrationShown = (): boolean =>
    !!sessionStorage.getItem(SEM_REGISTRATION_SHOWN_KEY);

export const shouldPromptSemRegistration = (): boolean => {
    const hasSemRegistrationQueryParam =
        new URLSearchParams(window.location.search).get('utm_content') === 'regmodal';

    return (
        hasSemRegistrationQueryParam &&
        !getUserId(document.cookie) &&
        !getEverLoggedIn(document.cookie) &&
        !wasSemRegistrationShown()
    );
};

export const promptSemRegistration = () => async (): Promise<void> => {
    importModuleAndRenderNotification({
        importFunc: importSemRegistrationModal,
    });
};

export default {
    name: 'semRegistrationPrompt',
    rule: shouldPromptSemRegistration,
    action: promptSemRegistration,
    priority: 370,
};
